<script>
  import { onMount, onDestroy } from "svelte";
  import { formatTime, formatPhone } from "../utils.js";

  import * as OrderDAL from "../dal/order-dal";
  import * as UserDAL from "../dal/user-dal";

  import { createEventDispatcher } from "svelte";
  import CartItem from "./CartItem.svelte";
  import DiscountItem from "./DiscountItem.svelte";
  import FaPhoneAlt from "svelte-icons/fa/FaPhoneAlt.svelte";
  import FaRegBellSlash from "svelte-icons/fa/FaRegBellSlash.svelte";
  import FaBell from "svelte-icons/fa/FaBell.svelte";
  import { showPopup, user } from "../stores";
  import LoadingAnim from "./LoadingAnim.svelte";
  import FaMapMarkerAlt from "svelte-icons/fa/FaMapMarkerAlt.svelte";

  export let order;
  let calcWaitInterval;
  let wait = "";
  let showOptionsMenu = false;
  let awaitingStatus;

  const dispatch = createEventDispatcher();

  const statuses = {
    waiting: 1,
    preparing: 2,
    ready: 3,
    paid: 4,
  };

  $: {
    if (awaitingStatus <= statuses[order.status]) {
      awaitingStatus = false;
    }
  }

  function showOptions(e) {
    showOptionsMenu = true;
    e.stopPropagation();
  }

  function hideOptions(e) {
    showOptionsMenu = false;
  }

  function getTime() {
    wait = formatTime(Date.now() - order.createdAt.seconds * 1000);
  }

  onMount(() => {
    getTime();
    calcWaitInterval = setInterval(getTime, 1000);
  });

  onDestroy(() => {
    clearInterval(calcWaitInterval);
  });

  $: console.log(order);

</script>

<svelte:body on:click={hideOptions} />

<div class="bg">
  <div class="top">
    <div class="optionsBtn" on:click={showOptions}>
      <img src="images/dots.svg" alt="order opetions" />
    </div>
    {#if showOptionsMenu}
      <div class="options">
        <!-- <div
          class="option"
          on:click={() => {
            didNotPay(order);
          }}
        >
          לא שולם
        </div> -->
        <div
          class="option"
          on:click={() => {
            dispatch('cancelOrder', order);
          }}
        >
          בטל הזמנה
        </div>
      </div>
    {/if}
    <div class="orderId">#{order.orderId}</div>
    <div class="waiting">- {wait}</div>
    <div class="phoneNumber">
      <span><FaPhoneAlt /></span>
      {formatPhone(order.phoneNumber)}
    </div>

    <div
      class="bell"
      class:ring={order.alert.on}
      class:disabled={!order.alert.on}
      on:click={async () => {
        if (order.alert.on) {
          OrderDAL.setOrderAlertOff(order.id, $user.uid);
        }
      }}
    >
      <span><FaBell /></span>
    </div>

    <div class="sum">סה"כ {order.sum} ₪</div>
  </div>
  <div class="items">
    {#each order.items as item}
      <div class="item">
        <CartItem {item} showRemoveBtn={false} itemStyle={'admin'} />
      </div>
    {/each}
  </div>
  {#if order.deliveryDetails}
    <div class="deliveryCartItem">
      <div class="name">משלוח:</div>
      <hr />
      <span> {order.deliveryDetails.price} ₪</span>
    </div>
  {/if}
  {#if order.notes}
    <div class="notes">* הערות: {order.notes}</div>
  {/if}
  {#if order.deliveryDetails}
    <div class="deliveryDetails">
      <div class="deliveryIcon">
        <img src="images/vespa.svg" alt="delivery icon" />
      </div>
      <div class="address">{order.deliveryDetails.address}</div>
      <div
        class="markerIcon"
        on:click={() => {
          window.open(`https://www.google.com/maps/search/?api=1&query=${order.deliveryDetails.address}`, '_blank');
        }}
      >
        <FaMapMarkerAlt />
      </div>
    </div>
  {/if}
  <div class="bottom">
    <div class="buttons">
      <button
        class:btnGreen={order.status == 'waiting' || awaitingStatus == statuses.waiting}
        class:btnDarkGreen={statuses[order.status] > statuses.waiting || (awaitingStatus && awaitingStatus > statuses.waiting)}
        on:click={async () => {
          try {
            if (order.status != 'waiting') {
              awaitingStatus = statuses.waiting;
              OrderDAL.setOrderStatus(order.id, 'waiting');
            }
          } catch (e) {
            showPopup('...משהו השתבש', () => {});
            UserDAL.sendLog('order waiting', e.toString());
            awaitingStatus = false;
          }
        }}
      >
        {#if awaitingStatus === statuses.waiting}
          <div class="btnLoadingAnim">
            <LoadingAnim />
          </div>
        {:else}ההזמנה התקבלה{/if}
      </button>
      <button
        class:btnGreen={order.status == 'preparing' || awaitingStatus == statuses.preparing}
        class:btnDarkGreen={(statuses[order.status] > statuses.preparing && !awaitingStatus) || awaitingStatus > statuses.preparing}
        on:click={async () => {
          OrderDAL.setOrderAlertOff(order.id, $user.uid);
          try {
            if (order.status != 'preparing') {
              awaitingStatus = statuses.preparing;
              OrderDAL.setOrderStatus(order.id, 'preparing');
            }
          } catch (e) {
            awaitingStatus = false;
            showPopup('...משהו השתבש', () => {});
            UserDAL.sendLog('order preparing', e.toString());
          }
        }}
      >
        {#if awaitingStatus === statuses.preparing}
          <div class="btnLoadingAnim">
            <LoadingAnim />
          </div>
        {:else}בהכנה{/if}
      </button>
      <button
        class:btnGreen={order.status == 'ready' || awaitingStatus == statuses.ready}
        class:btnDarkGreen={(statuses[order.status] > statuses.ready && !awaitingStatus) || awaitingStatus > statuses.ready}
        on:click={async () => {
          OrderDAL.setOrderAlertOff(order.id, $user.uid);
          try {
            if (order.status != 'ready') {
              awaitingStatus = statuses.ready;
              OrderDAL.orderReady(order);
            }
          } catch (e) {
            awaitingStatus = false;
            showPopup('...משהו השתבש', () => {});
            UserDAL.sendLog('order ready', e.toString());
          }
        }}
      >
        {#if awaitingStatus === statuses.ready}
          <div class="btnLoadingAnim">
            <LoadingAnim />
          </div>
        {:else if order.deliveryDetails}המשלוח בדרך{:else}מוכן{/if}
      </button>
      <button
        class:btnGreen={order.status == 'closed'}
        on:click={() => {
          OrderDAL.setOrderStatus(order.id, 'closed');
        }}
      >
        סיום
      </button>
    </div>
  </div>
</div>

<style>
  .deliveryCartItem {
    display: flex;
    align-items: center;
    font-size: 18px;
    margin: 20px 30px 30px 30px;
  }
  .deliveryCartItem > .name {
    display: list-item;
  }

  .deliveryCartItem > hr {
    width: 100%;
    border: none;
    border-bottom: 4px dotted gray;
    margin-left: 12px;
    margin-right: 12px;
    flex-grow: 1;
    min-width: 30px;
    height: 0px;
  }

  .deliveryCartItem > span {
    min-width: fit-content;
    font-size: 18px;
  }
  .deliveryDetails {
    display: flex;
    align-items: center;
    padding: 10px;
  }
  .deliveryIcon {
    background: var(--blue1);
    display: inline-flex;
    padding: 10px;
    border-radius: 100px;
  }

  .markerIcon {
    width: 30px;
    height: 30px;
    color: grey;
    margin-right: auto;
    border: 3px solid gray;
    padding: 8px;
    border-radius: 100px;
    cursor: pointer;
  }
  .deliveryIcon > img {
    width: 30px;
    height: 30px;
  }
  .address {
    margin-right: 10px;
  }
  .btnLoadingAnim {
    width: 100%;
    height: 100%;
    transform: scale(0.6) translateY(-16px);
  }

  .phoneNumber {
    direction: ltr;
    font-size: 16px;
    font-weight: 100;
    display: flex;
    align-items: center;
    margin-right: 24px;
  }

  .bell {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    position: relative;
    color: var(--grey1);
  }
  .bell.ring {
    z-index: 1;
    border-radius: 1000px;
    color: var(--red1);
  }

  .bell.ring::after {
    content: "";
    position: absolute;
    width: 30px;
    height: 30px;
    background: white;
    border-radius: 1000px;
  }

  .bell span {
    max-width: 18px;
    max-height: 27px;
    z-index: 1;
  }

  .bell.disabled span {
    color: #00000045;
  }
  .bell.ring::before {
    content: "";
    position: absolute;
    width: 50px;
    height: 50px;
    background: var(--red1);
    z-index: 0;
    border-radius: 1000px;
    transform: scale(0);
    animation: bleep 1.5s 0.35s ease-out infinite;
  }

  @keyframes bleep {
    0% {
      transform: scale(0);
      opacity: 1;
    }

    100% {
      transform: scale(1);
      opacity: 0;
    }
  }

  .phoneNumber span {
    width: 15px;
    height: 20px;
    display: inline-flex;
    margin-left: 15px;
    margin-right: 5px;
  }
  .bg {
    width: 100%;
    background: white;
    box-sizing: border-box;
    font-size: 18px;
    margin-bottom: 45px;
    box-shadow: 0px 30px 17px -26px #00000066, 0px -4px 12px -12px;
    border-radius: 15px 5px 25px 25px;
    overflow: hidden;
  }

  .top {
    padding-bottom: 0;
    padding-right: 10px;
    display: flex;
    justify-content: space-between;
    font-weight: 700;
    align-items: center;
    flex-wrap: wrap;
    position: relative;
    font-size: 18px;
  }

  .bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap-reverse;
  }

  .buttons {
    display: flex;
    align-items: center;
    height: 70px;
    font-size: 16px;
    width: 100%;
    border-radius: 0px 0px 25px 25px;
    overflow: hidden;
    cursor: pointer;
  }

  button {
    margin: 0;
    padding: 0;
    height: 100%;
    padding: 15px;
    width: 25%;
    border: none;
    border-right: 1px solid #0000002e;
    border-left: 1px solid #0000002e;
    color: white;
    background: grey;
    border-radius: 0;
    color: white;
    font-weight: 500;
    cursor: pointer;
  }

  .btnGreen {
    background: #29ff37;
  }

  .btnDarkGreen {
    background: #0ac917;
  }

  span {
    font-size: 26px;
    font-weight: 500;
  }

  .sum {
    align-self: flex-start;
    /* font-size: 20px; */
    font-weight: 400;
    min-width: max-content;
    text-align: left;
    margin-bottom: 5px;
    padding: 10px;
    background: var(--blue1);
    color: white;
    border-radius: 15px 0px 20px 0px;
  }

  .items {
    width: 100%;
    direction: rtl;
    background: white;
    border-radius: 4px;
    font-size: 16px;
    display: flex;
    flex-direction: column;
    position: relative;
    box-sizing: border-box;
    margin-top: 5px;
  }

  .item {
    padding: 10px;
  }

  .item:nth-child(odd) {
    background: #eee;
  }

  .item > .right {
    display: flex;
    align-items: center;
    min-width: fit-content;
  }

  .item > .left {
    min-width: fit-content;
    display: flex;
    align-items: center;
    font-size: 18px;
  }

  .waiting {
    margin-left: auto;
    margin-right: 14px;
    color: #6e6e6e;
    font-weight: 400;
    font-family: monospace;
  }

  .notes {
    padding: 6px 35px 15px 70px;
    font-size: 16px;
  }

  .optionsBtn {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: white;
    border-radius: 50px;
    margin: 5px;
    transition: background 0.3s;
  }

  .optionsBtn:hover,
  .optionsBtn:active {
    background: #e6e6e6;
  }

  .optionsBtn > img {
    height: 24px;
    padding: 5px 24px 5px 24px;
    opacity: 0.5;
  }

  .options {
    background: white;
    font-size: 17px;
    position: absolute;
    z-index: 999;
    top: 50px;
    right: 10px;
    width: 190px;
    display: flex;
    flex-direction: column;
    border-radius: 4px;
    color: #7e7e7e;
    font-weight: 400;
    box-shadow: 0px 7px 14px -11px black;
    border: 1px solid #d5d5d5;
    user-select: none;
  }

  .options > div {
    padding: 10px;
    border-bottom: 1px solid #d6d6d6;
  }

  .options > div:hover,
  .options > div:active {
    background: #e6e6e6;
  }

  .options > div:last-child {
    padding: 10px;
    border-bottom: none;
  }

  @media only screen and (max-width: 320px) {
    .top {
      font-size: 16px;
    }

    .notes {
      font-size: 14px;
    }
  }

  @media only screen and (max-width: 560px) {
    .bg {
      border-radius: 0;
    }
    .buttons {
      border-radius: 0;
    }
  }

</style>
